import { render } from "./MakeClientContract.vue?vue&type=template&id=aa1e67b4&scoped=true"
import script from "./MakeClientContract.vue?vue&type=script&lang=js"
export * from "./MakeClientContract.vue?vue&type=script&lang=js"

import "./MakeClientContract.vue?vue&type=style&index=0&id=aa1e67b4&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa1e67b4"]])

export default __exports__